import { render } from "./CardCourse.vue?vue&type=template&id=46b33c57"
import script from "./CardCourse.vue?vue&type=script&lang=js"
export * from "./CardCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__